/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/ComponentPages.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Component Page Reducers 
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 17, 2018 - 3:04 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/17/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    COMPONENTPAGE_LIST_CONTAINER_LOADED,
    COMPONENTPAGE_LIST_CONTAINER_UNLOADED,

    COMPONENTPAGE_LIST_TABLE_LOADED,
    COMPONENTPAGE_LIST_TABLE_UNLOADED,

    COMPONENTPAGE_LIST_CHANGE_GROUP_SELECT,
    COMPONENTPAGE_LIST_CHANGE_COMPONENT_SELECT,

    COMPONENTPAGE_SELECT_ROW,
    COMPONENTPAGE_ADD,
    COMPONENTPAGE_EDIT,
    COMPONENTPAGE_DELETE,
    COMPONENTPAGE_OPEN_WARNING,
    COMPONENTPAGE_CLOSE_WARNING,


    COMPONENTPAGE_EDIT_CONTAINER_LOADED,
    COMPONENTPAGE_EDIT_CONTAINER_UNLOADED,

    COMPONENTPAGE_EDIT_FORM_LOADED,
    COMPONENTPAGE_EDIT_FORM_UNLOADED,
    COMPONENTPAGE_EDIT_DATA_LOAD,
    COMPONENTPAGE_EDIT_CONTAINER_CANCEL,

    COMPONENTPAGE_EDIT_LOAD_GROUP_SELECT,
    COMPONENTPAGE_EDIT_DRAW_GROUP_SELECT,
    COMPONENTPAGE_EDIT_LOAD_COMPONENT_SELECT,
    COMPONENTPAGE_EDIT_DRAW_COMPONENT_SELECT    
} from '../constants/actionTypeComponentPages';

const defaultState = {
    refreshList: false,
    componentgroups: [],
    components: [],
    danger: false,
    componentpageid: 0,
    componentgroupid: 0,
    componentid: 0,
    name: '',
    description: '',
    path: '',
    entrypointid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case COMPONENTPAGE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                componentpages: action.payload[0] ? action.payload[0].records : [],
                componentgroups: action.payload[1] ? action.payload[1].componentgroups : [],
                components: action.payload[2] ? action.payload[2].records : []
            }
        case COMPONENTPAGE_LIST_CHANGE_GROUP_SELECT:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                componentpages: action.payload[0] ? action.payload[0].records : [],
                components: action.payload[1] ? action.payload[1].records : []
            }
        case COMPONENTPAGE_LIST_CHANGE_COMPONENT_SELECT:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                componentpages: action.payload[0] ? action.payload[0].records : []
            }
        case COMPONENTPAGE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case COMPONENTPAGE_SELECT_ROW:
            return {
                ...state,
                componentpageid: action.id
            }
        case COMPONENTPAGE_ADD:
            return {
                ...state
            }
        case COMPONENTPAGE_EDIT:
            return {
                ...state,
                componentpageid: action.id
            }
        case COMPONENTPAGE_DELETE:
            return {
                ...state,
                componentpageid: null
            }
        case COMPONENTPAGE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case COMPONENTPAGE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case COMPONENTPAGE_EDIT_LOAD_GROUP_SELECT:
            return {
                ...state,
                componentgroups: action.payload ? action.payload.componentgroups : []
            }
        case COMPONENTPAGE_EDIT_DRAW_GROUP_SELECT:
            return {
                ...state,
                componentGroupOptions: action.payload ? action.payload : []
            }
        case COMPONENTPAGE_EDIT_LOAD_COMPONENT_SELECT:
            return {
                ...state,
                components: action.payload ? action.payload.records : []
            }
        case COMPONENTPAGE_EDIT_DRAW_COMPONENT_SELECT:
            return {
                ...state,
                componentOptions: action.payload ? action.payload : [],
                componentDisabled: action.componentDisabled
            }

        case COMPONENTPAGE_EDIT_CONTAINER_LOADED:
            return {
                ...state
            }
        case COMPONENTPAGE_EDIT_DATA_LOAD:
            return {
                ...state,
                componentpageid: action.payload ? action.payload.componentpageid : 0,
                componentgroupid: action.payload ? action.payload.componentgroupid : 0,
                componentid: action.payload ? action.payload.componentid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                path: action.payload ? action.payload.path : '',
                entrypointid: action.payload ? action.payload.entrypointid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case COMPONENTPAGE_EDIT_FORM_LOADED:
            return {
                ...state
            }

        case COMPONENTPAGE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case COMPONENTPAGE_LIST_CONTAINER_UNLOADED:
        case COMPONENTPAGE_LIST_TABLE_UNLOADED:
        case COMPONENTPAGE_EDIT_CONTAINER_UNLOADED:
        case COMPONENTPAGE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/ComponentPages.js